define.alias("shared/modifiers/focus-on-destruct", "settings/modifiers/focus-on-destruct");